/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/849/interface/api/cat_13786
 */

import { message } from 'ant-design-vue'
import {
  common_getDict_get,
  common_googleTranslate_post,
  common_queryLanguageMapping_post,
  common_querySiteTerminals_post,
  common_refreshDictCache_get,
  common_siteById_get,
  common_siteByName_get,
  common_upsertDict_post
} from 'server/modules/13786'

// 查询四要素字典
export const common_getDict_get_ = async function(params) {
  const { success, data, retInfo } = await common_getDict_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 谷歌翻译
export const common_googleTranslate_post_ = async function(params) {
  const { success, data, retInfo } = await common_googleTranslate_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询语言信息
export const common_queryLanguageMapping_post_ = async function(params) {
  const { success, data, retInfo } = await common_queryLanguageMapping_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询站点列表
export const common_querySiteTerminals_post_ = async function(params) {
  const { success, data, retInfo } = await common_querySiteTerminals_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 刷新四要素字典缓存
export const common_refreshDictCache_get_ = async function(params) {
  const { success, data, retInfo } = await common_refreshDictCache_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询站点信息
export const common_siteById_get_ = async function(params) {
  const { success, data, retInfo } = await common_siteById_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询站点信息
export const common_siteByName_get_ = async function(params) {
  const { success, data, retInfo } = await common_siteByName_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 更新四要素字典
export const common_upsertDict_post_ = async function(params) {
  const { success, data, retInfo } = await common_upsertDict_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}
